/* ────────────────────────────────────────────────────────────────
   RS Swatch Deeplink — URL-parameter opener for email campaigns

   Lets a campaign link land the visitor with the shared
   #rs-swatch-modal already open:
     https://reveandsilk.com/?ls=<TOKEN>&swatch=1&src=email_aug-2026-1

   Requires swatch=1 exactly. The `src` param sets contact[Source] on
   the modal's hidden field (allowlisted — it lands in a notification
   email, so it is untrusted). Opens via the public rs-modal API.

   Owns NO persisted state: it never reads/writes
   localStorage['rs_swatch_prompt'] or sessionStorage['rs:swatch-return'].
   The scroll prompt's dismissal handler is scoped to prompt-initiated
   opens only, so a deep-link open cannot start its 30-day cooldown.

   Self-loaded (defer) AFTER rs-swatch-prompt.js in DOM order.
   ──────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  if (window.rsSwatchDeeplinkLoaded) return; // window-level double-load guard
  window.rsSwatchDeeplinkLoaded = true;

  var MODAL_ID = 'rs-swatch-modal';
  var SRC_ALLOW = /^[a-z0-9_-]{1,32}$/;
  var FALLBACK_SOURCE = 'email-campaign';

  function init() {
    /* Success-return load belongs to rs-swatch-return.js. A second
       showModal() on the same open <dialog> throws InvalidStateError. */
    if (document.querySelector('#' + MODAL_ID + ' [data-rs-form-success]')) return;

    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return; // no URLSearchParams support — bail silently
    }

    // Require swatch=1 exactly.
    if (params.get('swatch') !== '1') return;

    var modal = document.getElementById(MODAL_ID);
    if (!modal || !window.rsModal || typeof window.rsModal.open !== 'function') return;

    // Resolve Source — allowlist untrusted `src`, else fall back.
    var rawSrc = params.get('src');
    var source = (rawSrc && SRC_ALLOW.test(rawSrc)) ? rawSrc : FALLBACK_SOURCE;

    var srcField = document.querySelector('#' + MODAL_ID + ' [name="contact[Source]"]');
    if (srcField) srcField.value = source;

    /* Open on a macrotask so every DOMContentLoaded init handler has
       attached first — notably rs-swatch-prompt.js's openedThisView
       MutationObserver, which must register this open so the scroll
       prompt does not fire again later this page view. */
    setTimeout(function () {
      window.rsModal.open(MODAL_ID);
    }, 0);

    /* Strip ONLY our own params; preserve everything else (e.g. `ls`). */
    params.delete('swatch');
    params.delete('src');
    var qs = params.toString();
    var url = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    try {
      history.replaceState(null, '', url);
    } catch (e) { /* replaceState unavailable — non-fatal */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
